(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector =
      ".footer-content--legacy-pawswing > [data-block-id='footer_newsletter'], .footer-content--legacy-pawswing > [data-block-id$='__footer_newsletter']";
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    const initNewsletter = (root = document) => {
      root.querySelectorAll(selector).forEach((newsletter, index) => {
        const content = newsletter.querySelector(':scope > .group-block-content');
        if (!content) return;

        let toggle = newsletter.querySelector(':scope > .pawswing-footer-newsletter__toggle');
        if (!toggle) {
          const heading = content.querySelector('.text-block--newsletter_heading :is(h1, h2, h3, h4, h5, h6)');
          const label = heading?.textContent?.trim() || 'LUST AUF NEUIGKEITEN?';
          const contentId = content.id || `PawSwingFooterNewsletter-${index}`;
          content.id = contentId;

          toggle = document.createElement('button');
          toggle.type = 'button';
          toggle.className = 'pawswing-footer-newsletter__toggle';
          toggle.setAttribute('aria-controls', contentId);

          const labelElement = document.createElement('span');
          labelElement.textContent = label;
          const iconElement = document.createElement('span');
          iconElement.className = 'pawswing-footer-newsletter__toggle-icon';
          iconElement.setAttribute('aria-hidden', 'true');
          toggle.append(labelElement, iconElement);
          newsletter.insertBefore(toggle, content);

          toggle.addEventListener('click', () => {
            const isOpen = newsletter.dataset.footerNewsletterOpen === 'true';
            newsletter.dataset.footerNewsletterOpen = String(!isOpen);
            toggle.setAttribute('aria-expanded', String(!isOpen));
          });
        }

        const syncState = () => {
          const isMobile = mobileQuery.matches;
          newsletter.dataset.footerNewsletterReady = String(isMobile);

          if (!isMobile) {
            newsletter.dataset.footerNewsletterOpen = 'true';
            toggle.setAttribute('aria-expanded', 'true');
            return;
          }

          if (newsletter.dataset.footerNewsletterOpen !== 'true') {
            newsletter.dataset.footerNewsletterOpen = 'false';
            toggle.setAttribute('aria-expanded', 'false');
          }
        };

        syncState();

        if (newsletter.dataset.footerNewsletterInitialized !== 'true') {
          newsletter.dataset.footerNewsletterInitialized = 'true';
          mobileQuery.addEventListener?.('change', syncState);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initNewsletter());
    } else {
      initNewsletter();
    }

    document.addEventListener('shopify:section:load', (event) => initNewsletter(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-image"] && !Shopify.designMode) return;
  try {
    
  if (!window.pawswingHotspotsBound) {
    window.pawswingHotspotsBound = true;

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-pawswing-hotspot-button]');
      const openHotspots = document.querySelectorAll('.pawswing-shoppable-image__hotspot[data-open="true"]');

      if (!button) {
        if (!event.target.closest('.pawswing-shoppable-image__hotspot')) {
          openHotspots.forEach((hotspot) => {
            hotspot.removeAttribute('data-open');
            hotspot.querySelector('[data-pawswing-hotspot-button]')?.setAttribute('aria-expanded', 'false');
            hotspot.querySelector('.pawswing-shoppable-image__card')?.setAttribute('aria-hidden', 'true');
          });
        }
        return;
      }

      const hotspot = button.closest('.pawswing-shoppable-image__hotspot');
      const card = hotspot?.querySelector('.pawswing-shoppable-image__card');
      const shouldOpen = hotspot?.getAttribute('data-open') !== 'true';

      openHotspots.forEach((openHotspot) => {
        if (openHotspot !== hotspot) {
          openHotspot.removeAttribute('data-open');
          openHotspot.querySelector('[data-pawswing-hotspot-button]')?.setAttribute('aria-expanded', 'false');
          openHotspot.querySelector('.pawswing-shoppable-image__card')?.setAttribute('aria-hidden', 'true');
        }
      });

      if (hotspot && card) {
        hotspot.toggleAttribute('data-open', shouldOpen);
        button.setAttribute('aria-expanded', String(shouldOpen));
        card.setAttribute('aria-hidden', String(!shouldOpen));
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      document.querySelectorAll('.pawswing-shoppable-image__hotspot[data-open="true"]').forEach((hotspot) => {
        hotspot.removeAttribute('data-open');
        hotspot.querySelector('[data-pawswing-hotspot-button]')?.setAttribute('aria-expanded', 'false');
        hotspot.querySelector('.pawswing-shoppable-image__card')?.setAttribute('aria-hidden', 'true');
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
